import { userConstants } from '../_constants';
import { alertActions } from './alert.actions';
import { APIcallFunction, headerForPublicAPI, logoutFunction, headerForPrivateAPI, apiCallFunctionSecond } from '../_helpers';
export const userActions = {
  login,
  logout,
  updatePassword,
  getloginHistoryList,
  getSwappingList,
  getSwappingDetailsList,
  updateSwapStatus,
  getMerchantRequestList,
  updateMerchantStatus,
  getMerchantAccountInformation,
  getMerchantRequestDetails,
  merchantRequestRejectionReasons,
  getNotificationListAdmin,
  approveOrRejectMerchantContract,
  verifiedMerchant,
  getAdminProfile,updateProfile,
  getSwappingDetails

};
function login(data, navigate) {
  const credentials = {
    header: headerForPublicAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/admin/login'
  }
  return dispatch => {
    dispatch(request({ data }));
    APIcallFunction(credentials)
      .then(
        user => {
          window.sessionStorage.setItem("PKRD_Administration", JSON.stringify(user.data))
          dispatch(success(user));
          dispatch(alertActions.success("Signed in successfully."));
          if (navigate) {
            navigate('/app/dashboard'); // Navigate to a different route
            window.location.reload(); // Reload the page
          }

        },
        error => {
          dispatch(failure(error));
          dispatch(alertActions.error(error));
        }
      );
  };
  function request(user) { return { type: userConstants.LOGIN_REQUEST, user } }
  function success(user) { return { type: userConstants.LOGIN_SUCCESS, user } }
  function failure(error) { return { type: userConstants.LOGIN_FAILURE, error } }
}

function logout() {
  logoutFunction()
  return { type: userConstants.LOGOUT };
}

//change Password
function updatePassword(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/admin/updatePasswordAdmin'
  }
  return APIcallFunction(credentials)
}


function updateProfile(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/admin/updateProfile'
  }
  return APIcallFunction(credentials)
}

function getloginHistoryList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/admin/getLoginHistory'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
        //dispatch(alertActions.success("Data Found"));
      },
      (error) => {
        dispatch(failure(error));
        // dispatch(alertActions.error(error));
      }
    );
  };
  function request(user) { return { type: userConstants.GET_LOGINHISTORY_LIST_REQUEST, user } }
  function success(user) { return { type: userConstants.GET_LOGINHISTORY_LIST_SUCCESS, user } }
  function failure(error) { return { type: userConstants.GET_LOGINHISTORY_LIST_FAILURE, error } }
}

function getMerchantRequestList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchant/merchantRequestList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };
  function request(user) { return { type: userConstants.GET_MERCHANT_LIST_REQUEST, user } }
  function success(user) { return { type: userConstants.GET_MERCHANT_LIST_SUCCESS, user } }
  function failure(error) { return { type: userConstants.GET_MERCHANT_LIST_FAILURE, error } }
}

function getSwappingList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/swap/swappingList'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };
  function request(user) { return { type: userConstants.GET_SWAPPING_LIST_REQUEST, user } }
  function success(user) { return { type: userConstants.GET_SWAPPING_LIST_SUCCESS, user } }
  function failure(error) { return { type: userConstants.GET_SWAPPING_LIST_FAILURE, error } }
};

function getSwappingDetailsList(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/swap/getSwappingDetails'
  }
  return APIcallFunction(credentials)
};


function getSwappingDetails(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/swap/getSwappingDetails'
  }
  return APIcallFunction(credentials)
};








function getNotificationListAdmin(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/notification/getNotificationListAdmin'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };
  function request(user) { return { type: userConstants.GET_NOTIFICATION_LIST_REQUEST, user } }
  function success(user) { return { type: userConstants.GET_NOTIFICATION_LIST_SUCCESS, user } }
  function failure(error) { return { type: userConstants.GET_NOTIFICATION_LIST_FAILURE, error } }
};

function updateSwapStatus(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/swap/approveOrRejectSwappingRequest'
  }
  return APIcallFunction(credentials)
}

function updateMerchantStatus(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchant/approveOrRejectMerchantRequest'
  }
  return APIcallFunction(credentials)
}

function getMerchantAccountInformation(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchant/getMerchantAccountInformation'
  }
  return APIcallFunction(credentials)
}

function getMerchantRequestDetails(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchant/getMerchantRequestDetails'
  }
  return APIcallFunction(credentials)
}

function merchantRequestRejectionReasons(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchant/merchantRequestRejectionReasons'
  }
  return APIcallFunction(credentials)
}



function approveOrRejectMerchantContract(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchant/approveOrRejectMerchantContract'
  }
  return apiCallFunctionSecond(credentials)
}

function verifiedMerchant(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/merchant/verifiedMerchant'
  }
  return apiCallFunctionSecond(credentials)
}


function getAdminProfile(data) {
  const credentials = {
    header: headerForPrivateAPI,
    method: "POST",
    body: data ?? {},
    endPoint: '/admin/getAdminProfile'
  }
  return (dispatch) => {
    dispatch(request({ data }));
    APIcallFunction(credentials).then(
      (user) => {
        dispatch(success(user));
      },
      (error) => {
        dispatch(failure(error));
      }
    );
  };
  function request(user) { return { type: userConstants.GET_PROFILE_LIST_REQUEST, user } }
  function success(user) { return { type: userConstants.GET_PROFILE_LIST_SUCCESS, user } }
  function failure(error) { return { type: userConstants.GET_PROFILE_LIST_FAILURE, error } }
};